import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { globalService } from "./GlobalService";
import { format } from 'date-fns';

const customAxios: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-type": "application/json",
    //Don't pass token here. On Login its taking previous user token
    //Authorization: `Bearer  ${userService.useAuth().Token}`,
    //Authorization: `Bearer  ${localStorage.getItem("token")}`,
  },
});

interface RetryConfig extends AxiosRequestConfig {
  retry: number;
  retryDelay: number;
}

const axiosRetryConfig: RetryConfig = {
  retry: 1,
  retryDelay: 1000,
};

// Add a request interceptor
// function cleanJSON(json : any) {
//
//   for (let key in json) {
//       if (json[key] === undefined || json[key] === "") {
//           json[key] = null;
//       } else if (typeof json[key] === 'object')
//           json[key] = cleanJSON(json[key]);
//   }
//   return json;
// }



const dateOnlyFields = new Set([
  'Reconciled', 'BillDate', 'FromDate', 'ToDate', 'DocDate', 'PayRefDate',
  'DelDocDate', 'Reconciled', 'LockedTillDate', 'PaidTillDate', 'ReconciledOn', 'AsOnDate',
  'DueDate', 'BillEndDate', 'RegistrationDate', 'IssueDate', 'TransferDate', 'UEndDate',
  'TdsdepositDate', 'ReversalDate', 'StartRange', 'EndRange', 'ReceiptDate',
  'LoanClearedOn', 'EnteranceFeePaidOn', 'BirthDate', 'NominationDate', 'RevocationDate',
  'Mcmdate', 'RealizationDate', 'ClosureDate', 'ChequeDate', 'MaturityDate', 'DocumentDate', 'PossessionStartDate',
  'PossessionEndDate', 'ReversalDate', 'StartDate', 'EndDate', 'TransferredOn', 'SubscriptionStart', 'SubscriptionEnd', 'Wef',
  'CertificateDate', 'ValidityStart', 'ValidityEnd', 'UMinDate', 'UMaxDate', 'PayDate', '', '', '', '', '', '', '',
]);

// Converts only specified fields to `yyyy-MM-dd`
const convertDateTimesToISODate = (data: any, fieldsToFormat: string[]): any => {
  if (typeof data !== 'object' || data === null) return data;

  const result: any = { ...data };

  fieldsToFormat.forEach(field => {
    const value = result[field];
    if (value) {
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        result[field] = format(date, 'yyyy-MM-dd');
      }
    }
  });

  return result;
};

const replacer = function (key: any, value: any) {
  return typeof value === "undefined" || value === "" ? null : value;
};

customAxios.interceptors.request.use(
  function (config: any) {
    const method = config.method?.toLowerCase();
    config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;

    if (["post", "put", "patch"].includes(method) && config.data) {
      const contentType = config.headers?.getContentType?.() ?? config.headers?.['Content-Type'];

      // Case 1: multipart/form-data
      if (contentType?.includes("multipart/form-data")) {
        const jsonData = config.data.get("data");
        if (jsonData) {
          try {
            const parsedData = JSON.parse(jsonData as string);
            const fieldsToFormat = Object.keys(parsedData).filter(field => dateOnlyFields.has(field));
            const updatedData = convertDateTimesToISODate(parsedData, fieldsToFormat);
            const stringifiedData = JSON.stringify(updatedData, replacer);
            config.data.set("data", stringifiedData);
          } catch (e) {
            console.error("Invalid JSON in FormData:", e);
          }
        }
      } else {
        // Case 2: regular JSON body
        let originalData = config.data;

        if (typeof originalData === "string") {
          try {
            originalData = JSON.parse(originalData);
          } catch (e) {
            console.error("Failed to parse config.data as JSON:", e);
          }
        }

        if (originalData && typeof originalData === 'object') {
          const fieldsToFormat = Object.keys(originalData).filter(field => dateOnlyFields.has(field));
          if (fieldsToFormat.length > 0) {
            const updatedData = convertDateTimesToISODate(originalData, fieldsToFormat);
            config.data = JSON.stringify(updatedData, replacer);
          } else {
            config.data = JSON.stringify(originalData, replacer);
          }
        }
      }
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

customAxios.interceptors.response.use(
  // response => {
  //
  //   var replacer = function (key: any, value: any) {
  //     return typeof value === null ? '' : value;
  //   }
  //   response.data = JSON.stringify( response.data, replacer);
  //   return response;
  // },
  (response) => response,
  (error) => {
    ///////////ERROR Handling and Display//////////
    let errMessage = "";

    console.log(error);
    ///////////////////////////////////////////

    /////////////////////////////////////
    if (error.response) {
      if (error.response?.data) {
        if (error.response.request?.responseType === "blob") {
          errMessage = "Could not create file. Error/No data found.";
        } else {
          errMessage = error.response.data.message;
        }
      }

      if (error.response?.status === 401) {
        errMessage = "401 - UnAuthorized.";
        globalService.clearLocalStorageExcept1();
        window.location.href = "/login";
      }
      else if (error.response?.status === 403) {
        errMessage = "403 - Forbidden. User is not permitted to access this method.";
      }
      else if (error.response?.status === 404) {
        errMessage = "API not found. Please check API path.";
      } else if (error.response?.status === 405) {
        errMessage =
          "405 - Method Not allowed. Please check API path/parameter.";
      } else if (error.response?.status === 0) {
        errMessage = "Connection Refused By Remote Server.";
        globalService.clearLocalStorageExcept1();
        //window.location.href = '/login';
      } else if (error.response?.status === 400) {
        if (errMessage?.startsWith("Error converting value")) errMessage = "";
        else if (error.response?.data?.message) errMessage = error.response.data.message;
        else errMessage = errMessage ? errMessage : error.message;
      }
    } else {
      if (error.code === "ERR_NETWORK") {
        errMessage = "Connection Refused By Remote Server.";
        //localStorage.clear();
        //window.location.href = '/login'; //error log getting removed from console.
      } else errMessage = error.message;
    }
    //this is showing error converting value. Large popup with all posted data
    //globalService.error(errMessage ? errMessage : error.code + " : " + error.message);
    if (errMessage) globalService.error(errMessage);
    //////////////Ends Error handling and display//////////
    ///////////////////RETRY Requests//////////////////
    const { config } = error;

    if (!config || !config.retry) {
      return Promise.reject(error);
    }
    config.retry -= 1;
    const delayRetryRequest = new Promise<void>((resolve) => {
      setTimeout(() => {
        console.log("retry the request", config.url);
        resolve();
      }, config.retryDelay || 1000);
    });
    return delayRetryRequest.then(() => customAxios(config));
    ///////////////////ENDS RETRY Requests//////////////////
  }
);

export { customAxios, axiosRetryConfig };
